module.exports = __webpack_public_path__ + "img/my-profile-blue.24db3d38.svg";